import type { Cart } from '~/modules/GraphQL/types';

import { CartResultUnconfirmedError } from './cartCoordinator';

/** Only a complete cart result can confirm a write; preserve definite business rejections. */
export function confirmedMutationCart(
  response: any,
  field: string,
  expectedCartId: string,
  fallbackMessage?: string,
): Cart {
  const operation = response?.data?.[field];
  if (response?.errors?.length) {
    const message = response.errors[0]?.message || fallbackMessage || 'Cart operation rejected.';
    if (operation !== null && operation !== undefined) {
      throw new CartResultUnconfirmedError(message);
    }
    throw new Error(message);
  }
  if (operation?.user_errors?.length) {
    const message = operation.user_errors[0]?.message || fallbackMessage || 'Cart operation rejected.';
    // Batch adds can have accepted some products before returning user_errors.
    if (operation.cart) throw new CartResultUnconfirmedError(message);
    throw new Error(message);
  }
  const cart = operation?.cart;
  if (!cart?.id || cart.id !== expectedCartId || !Array.isArray(cart.items)) {
    throw new CartResultUnconfirmedError(fallbackMessage);
  }
  return cart;
}
